export default __webpack_public_path__ + "static/media/1-blur-gallary-file-24-px-light-blue.4c281768.svg";